var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#545860;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deelo-icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.25,21.25H28.75V3.75a3.75,3.75,0,0,0-7.5,0v17.5H3.75a3.75,3.75,0,0,0,0,7.5h17.5v17.5a3.75,3.75,0,0,0,7.5,0V28.75h17.5a3.75,3.75,0,0,0,0-7.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGr);
export default __webpack_public_path__ + "static/media/add-gr.ea8f2e20b3cfe1802e8cf1e654991505.svg";
export { ForwardRef as ReactComponent };